// src/components/BookDemoPopup.tsx
import React from "react";
import { motion } from "framer-motion";

interface BookDemoPopupProps {
  isOpen: boolean;
  onClose: () => void;
}

const BookDemoPopup: React.FC<BookDemoPopupProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 px-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="bg-white rounded-2xl shadow-2xl border border-gray-100 max-w-md w-full p-8 relative overflow-hidden"
      >
        <div className="absolute top-0 right-0 -mr-10 -mt-10 w-32 h-32 bg-orange-100 rounded-full blur-2xl opacity-50"></div>
        <div className="absolute bottom-0 left-0 -ml-10 -mb-10 w-32 h-32 bg-blue-100 rounded-full blur-2xl opacity-50"></div>

        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-900 transition-colors"
        >
          <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        <h2 className="text-3xl font-black text-gray-900 mb-2 tracking-tight relative z-10">Book a Demo</h2>
        <p className="text-gray-600 mb-8 relative z-10 leading-relaxed">
          Get in touch with us to schedule a personalized demo for your
          restaurant.
        </p>

        {/* Contact Info */}
        <div className="space-y-4 text-gray-700 relative z-10 bg-gray-50 p-6 rounded-xl border border-gray-100">
          <div className="flex items-center gap-3">
             <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center text-orange-600">
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
             </div>
             <div>
               <p className="text-xs text-gray-500 uppercase font-bold tracking-wider">Phone</p>
               <p className="text-gray-900 font-medium">+91 8767820053</p>
             </div>
          </div>
          
          <div className="h-px bg-gray-200"></div>

          <div className="flex items-center gap-3">
             <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600">
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
             </div>
             <div>
               <p className="text-xs text-gray-500 uppercase font-bold tracking-wider">Email</p>
               <p className="text-gray-900 font-medium">admin@willovate.in</p>
             </div>
          </div>

          <div className="h-px bg-gray-200"></div>

          <div className="flex items-center gap-3">
             <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center text-purple-600">
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
             </div>
             <div>
               <p className="text-xs text-gray-500 uppercase font-bold tracking-wider">Address</p>
               <p className="text-gray-900 font-medium">Nagpur, Maharashtra, India</p>
             </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default BookDemoPopup;
